import { useQuery } from '@tanstack/react-query';
import useApi from 'hooks/useApi';
import { useRouter } from 'next/router';
import cardsFactory from 'utils/factories/card';

const useCardVariants = (reference: string) => {
  const apiClient = useApi();
  const { locale } = useRouter();

  const queryKey = cardsFactory.variants(reference);

  const { data, status, isLoading } = useQuery({
    queryKey,
    queryFn: async () => apiClient.cards.cardsReferenceVariants(reference, { locale: locale! }),
    select: (res) => res.data,
  });

  return { variants: data?.['hydra:member'], totalItems: data?.['hydra:totalItems'], status, isLoading };
};

export default useCardVariants;
